import PubSub from "underpub-js";

var Breadcrumb = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-Breadcrumb',
	};

	$.extend(true, this.options, options);

};

Breadcrumb.prototype.init = function() {

	var self = this;

};

export default Breadcrumb;
